/**
 * Repo path RegEx.
 */
export const repo = /^(\/repos\/)(.+)/;
/**
 * User path RegEx.
 */
export const user = /^(\/users\/)(.+)/;
